(() => {
  'use strict';
  if (customElements.get('oc-napa-quote')) return;
  class OCNapaQuote extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => this.initialize());
    }
    initialize() {
      if (this._initialized || !this.isConnected) return;
      this._initialized = true;
      this.form = this.querySelector('form');
      this.native = this.querySelector('[data-native-variant]');
      if (!this.form || !this.native) return;
      this.selects = Array.from(this.querySelectorAll('[data-option-index]'));
      this.status = this.querySelector('[data-selection-status]');
      this.sku = this.querySelector('[data-selected-sku]');
      this.optionsText = this.querySelector('[data-selected-options]');
      this.button = this.querySelector('[data-quote-submit]');
      this.fields = [this.querySelector('[data-quote-variant]'), this.querySelector('[data-quote-sku]'), this.querySelector('[data-quote-options]')];
      try {
        this.data = JSON.parse(this.querySelector('[data-quote-payload]').textContent);
        if (!this.data || String(this.data.productId) !== this.dataset.productId ||
            !Array.isArray(this.data.variants) || this.data.complete !== true ||
            this.data.variantTotal !== this.data.variants.length ||
            this.data.variantTotal < 1 || this.data.variantTotal >= 250 ||
            !this.selects.length || !this.fields.every(Boolean)) throw Error();
        const keys = new Set();
        const ids = new Set();
        const skus = new Set();
        for (const v of this.data.variants) {
          if (!v || !Array.isArray(v.options) || v.options.length !== this.selects.length ||
              !v.options.every(x => typeof x === 'string') || v.id == null ||
              typeof v.sku !== 'string' || !v.sku.trim()) throw Error();
          const key = JSON.stringify(v.options);
          const id = String(v.id);
          if (keys.has(key) || ids.has(id) || skus.has(v.sku)) throw Error();
          const nativeOption = Array.from(this.native.options).find(option => option.dataset.variantId === id);
          if (!nativeOption || nativeOption.disabled) throw Error();
          keys.add(key); ids.add(id); skus.add(v.sku);
        }
        if (this.native.options.length !== this.data.variantTotal + 1) throw Error();
      } catch (_) {
        this.fail();
        return;
      }
      this.native.required = false;
      this.querySelector('[data-native-configuration]').hidden = true;
      this.querySelector('[data-enhanced-options]').hidden = false;
      this.selects.forEach(select => select.addEventListener('change', () => this.resolve()));
      this.form.addEventListener('submit', event => {
        this.resolve();
        if (!this.current || !this.form.checkValidity()) {
          event.preventDefault();
          this.form.reportValidity();
        }
      });
      this.resolve();
    }
    clearIdentity() {
      this.current = null;
      this.native.selectedIndex = -1;
      this.fields.forEach(field => {
        if (field) { field.value = ''; field.disabled = true; }
      });
      if (this.sku) this.sku.textContent = '';
      if (this.optionsText) this.optionsText.textContent = '';
      if (this.button) this.button.disabled = true;
    }
    fail() {
      this.clearIdentity();
      if (this.status) this.status.textContent = this.dataset.unavailableMessage;
      this.native.disabled = true;
      this.selects.forEach(select => { select.disabled = true; });
      this.form.addEventListener('submit', event => event.preventDefault());
    }
    resolve() {
      const selected = this.selects.map(select => select.value);
      const variant = this.data.variants.find(v => v.options.every((value, index) => value === selected[index])) || null;
      this.clearIdentity();
      if (!variant) {
        this.status.textContent = this.data.messages.noMatch;
        return;
      }
      const option = Array.from(this.native.options).find(item => item.dataset.variantId === String(variant.id));
      if (!option || option.disabled) { this.fail(); return; }
      this.current = variant;
      this.native.value = option.value;
      const values = [String(variant.id), variant.sku, this.selects.map(select => select.dataset.optionName + ': ' + select.value).join(' / ')];
      this.fields.forEach((field, index) => { field.value = values[index]; field.disabled = false; });
      this.sku.textContent = variant.sku;
      this.optionsText.textContent = selected.join(' / ');
      this.status.textContent = this.data.messages.selection;
      this.button.disabled = false;
    }
  }
  customElements.define('oc-napa-quote', OCNapaQuote);
})();
